export default (...classNames) => classNames.filter(Boolean).join(' ');
